import * as React from "react";
const SvgFiRrSpaceShuttle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-space-shuttle_svg__a)">
      <path
        fill="#062147"
        d="M21.794 9.058a8.6 8.6 0 0 0-4.21-1.053H13.55l-3.045-5.437A5 5 0 0 0 6.148.016H4.994a2.996 2.996 0 0 0-2.997 2.996v1.997a.999.999 0 0 0 1.998 0V3.012c0-.552.447-.999.999-.999h1.154c1.084 0 2.084.586 2.614 1.532l2.499 4.46H2.996A2.996 2.996 0 0 0 0 11.001V13a2.996 2.996 0 0 0 2.996 2.996h8.264l-2.496 4.46a3 3 0 0 1-2.616 1.532H4.994a1 1 0 0 1-1-.999v-1.997a.999.999 0 1 0-1.997 0v1.997a2.996 2.996 0 0 0 2.996 2.997h1.155a5 5 0 0 0 4.356-2.553l3.045-5.437h4.035a8.6 8.6 0 0 0 4.21-1.053c2.94-1.744 2.943-4.14 0-5.884m-5.088 4.94H5.992v-3.995h10.713a2.222 2.222 0 0 1 .001 3.995m-14.709-1v-1.997c0-.551.448-.998 1-.998h.998v3.995h-.999a1 1 0 0 1-.999-1m18.818.2a6 6 0 0 1-1.238.517 4 4 0 0 0 0-3.436c.43.125.846.298 1.238.517 1.527.882 1.527 1.527 0 2.403"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-space-shuttle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpaceShuttle;
